import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('basic-video', () => import(/* webpackMode: "lazy" */'./basic-video'));
